import React from 'react';
import { observer } from 'mobx-react';

// Translation
import translate from '../../translate/Translate';

const ReportAppendix = observer(
  class ReportAppendix extends React.Component {

    componentDidMount() {
      const { page, store } = this.props;
      const { ActivityStore, AppStore } = store;
      const { locale } = AppStore;

      ActivityStore.sendPageViewActivity({
        pageUrl: window.location.href,
        view: this.constructor.name,
        title: page.title[locale],
        reportSid: page.reportSid
      });
    }

    renderResourceLinks = (section) => {
      const { handleResource, store, page } = this.props;
      const { AppStore } = store;
      const { locale } = AppStore;

      let links = [];

      if (section.content) {
        section.content.forEach((item) => {
          item.value.links.forEach(link => links.push(link))
        });
      }

      return (
        <ul className="resource-list">
          {links.map((link, i) => (
            <li key={i} className="resource-list__item">
              <a
                href={link.url}
                className="resource-list__link"
                onClick={() => handleResource(link, page.reportSid)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.label[locale]}
              </a>
            </li> 
          ))}
        </ul>
      );
    }

    render() {
      const { page, store, translation } = this.props;
      const { AppStore, ReportStore } = store;
      const { locale } = AppStore;
      const { appendix } = ReportStore;

      return (
        <div className="page__content wrap">
          <article className="page__primary">
            <h1 id="page-title" className="page__heading">
              {page.title[locale]}
            </h1>

            <p>{translation.intro}</p>

            {appendix.map((page, i) => (
              <section key={i} aria-labelledby={`section-head-${i}`}>
                <h2 className="page__heading" id={`section-head-${i}`}>{page.title[locale]}</h2>
                {page.sections && page.sections.map((section, j) => (
                  
                  <React.Fragment key={j}>
                    {section.heading && 
                      <h3>{section.heading[locale]}</h3>
                    }
                    {this.renderResourceLinks(section)}
                  </React.Fragment>
                ))}
              </section>
            ))}
          </article>
        </div>
      );
    }
  }
);

export default translate('ReportAppendix')(ReportAppendix);
